// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ijDsE","content":"styles_content__1MECH"};